import script from "./title.component.vue?vue&type=script&lang=js"
export * from "./title.component.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__